// reducer.js
import { POST_DATA_REQUEST, POST_DATA_SUCCESS, POST_DATA_FAILURE, POST_DATA_RESET } from '../../../Constants/actionTypes';

const initialState = {
  loading: false,
  data: null,
  error: null,
  onSuccess: false,
};

const postDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case POST_DATA_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        onSuccess: false,
      };
    case POST_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        onSuccess: true,
      };
    case POST_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        onSuccess: false,
      };
    case POST_DATA_RESET:
      return {
        ...state,
        onSuccess: false,
        error:null
      };
    default:
      return state;
  }
};

export default postDataReducer;
